import termsApis from '../../../apis/terms';
import { SnackbarSeverityType } from '../../../enums';

const fetchTermIdsForClass = async (
  school: string,
  academicYear: string,
  grade: string,
  division: string,
  showToast?: (msg: string, sev: SnackbarSeverityType) => void
): Promise<string[]> => {
  try {
    const response = await termsApis.getTermsForClass(
      school,
      academicYear,
      grade,
      division
    );

    const data = response?.data || response;

    if (Array.isArray(data)) {
      return data.map((term: any) => term.id).filter(Boolean);
    }

    if (Array.isArray(data?.data)) {
      return data.data.map((term: any) => term.id).filter(Boolean);
    }

    return [];
  } catch (e) {
    showToast?.('Failed to fetch terms', SnackbarSeverityType.error);
    return [];
  }
};

export default fetchTermIdsForClass;
